import * as TYPES from './workflow-actiontypes';

export const initialState = {
  isDedicatedWorkflow: false,
};

export const workflowReducer = (state = initialState, action) => {
  let newState = state;
  switch (action.type) {
    case TYPES.SET_ISDEDICATED_WORKFLOW:
      newState = { ...state, isDedicatedWorkflow: action.isDedicatedWorkflow };
      break;
    default:
      newState = state;
  }

  return newState;
};

export default workflowReducer;
